<template>
  <div class="door-item">
    <!--  -->
    <div class="item-left">
      <img class="door-item-icon" src="@/assets/image/share-door.png" mode="widthFix" />
      <span class="door-item-text">{{ text.deviceName }}</span>
    </div>
    <div class="item-right">
      <div class="times">
        <div class="label">可开次数</div>
        <div class="num">{{ text.openTimes === -1 ? '无限' : text.openTimes }}次</div>
      </div>
      <div class="btn" @click="handleDoor(text)" :class="{'disabled': !text.allow}">点击开门</div>
    </div>
  </div>
</template>

<script>
import { NetService } from '@/service'
import { Dialog, Toast } from 'vant'
import Vue from 'vue'
Vue.use(Dialog)
Vue.use(Toast)
export default {
  props: {
    text: Object
  },
  methods: {
    handleDoor(item) {
      if (!item.allow) return
      let loading = Toast.loading('开门中...')
      try {
        NetService.OpenDoor(item.id).then(res => {
          // console.log(res, '=====')
          if (res.data) {
            setTimeout(() => {
              this.checkOpendDoorStateAgain(res.data)
            }, 2000)
          }
          // loading.clear()
        }).catch(err => {
          console.log(err.data)
          if (err.data) {
            setTimeout(() => {
              this.checkOpendDoorStateAgain(err.data)
            }, 2000);
          }
        })
      } catch (error) {
        // console.log(error)
        loading.clear()
      }
    },
    checkOpendDoorStateAgain(sn) {
      try {
        NetService.CheckDoorStatus(sn).then(respon => {
          if (respon && respon.processStatus === '2') {
            Toast({ duration: 2000, message: '开门成功' })
            setTimeout(() => {
              this.$emit('refresh')
            }, 1500);
          } else if (respon && respon.processStatus === '0') {
            Toast({ duration: 2000, message: '开门失败' })
          }
        })
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.door-item {
  padding: 30px 0;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #F5F5F5;
  &:last-child {
    border-bottom: none;
  }
  .item-left {
    flex: 1;
    margin-right: 20px;
    display: flex;
    align-items: center;
    img {
      width: 48px;
      height: 48px;
    }
    .door-item-text {
      font-size: 26px;
      color: #000;
      margin-left: 20px;
      line-height: 40px;
      flex: 1;
    }
  }
  .item-right {
    display: flex;
    align-items: center;
    .times {
      text-align: right;
      margin-right: 20px;
      font-size: 24px;
      flex: 1;
      .num {
        margin-top: 10px;
      }
    }
    .btn {
      width: 132px;
      height: 70px;
      background: #FF8B5C;
      border-radius: 6px 6px 6px 6px;
      text-align: center;
      line-height: 70px;
      color: #fff;
      font-size: 24px;
      &.disabled {
        background: #f6f6f6;
        color: #666;
      }
    }
  }

  // border-radius: 24px 24px 24px 0;
  // background-color: rgba(255, 196, 110, 0.3);
  // @extend .flex-row-center;
  // &-icon {
  //   width: 16px;
  //   height: 22px;
  // }
  // &-text {
  //   margin-left: 12px;
  //   @include text(20px, bold, rgb(245, 203, 158));
  // }
}
</style>
